export class GvfNetworkError extends Error {
    constructor(m?: string) {
        if(!m) {
            m = 'Error with gvf';
        }
        super(m);
    }
}